import { makeStyles } from '@material-ui/core';
import { getLargeDrawerPaperStyles } from 'UI/constants/styles';

export const useDrawerStyles = makeStyles(theme => ({
  drawerLarge: {
    ...getLargeDrawerPaperStyles(theme),
    overflowY: 'hidden'
  },
  drawerContent: {
    padding: 0,
    flexGrow: 1,
    overflowY: 'auto'
  }
}));
